{
  "(optional)": "(optioneel)",
  "(required)": "(vereist)"
}
